import React from 'react';
import { translate } from '../../base/i18n/functions';
import { connect } from 'react-redux';
import { AbstractWelcomePage, _mapStateToProps } from './AbstractWelcomePage';
// @ts-ignore
import { getServiceName } from '../../utils/brandUtils';
class GreetingsPopup extends AbstractWelcomePage {
    serviceName = getServiceName();
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            hide: true
        };
    }
    render() {
        var name = "";
        let us = localStorage.getItem("user");
        if (us != null) {
            var user = JSON.parse(us?.toString());
            if (user.result == 1) {
                name = user.name;
            }
        }
        return (React.createElement("div", { className: "modal" },
            React.createElement("div", { className: "modal-content" },
                React.createElement("span", { className: "close", onClick: this.props.closePopup }, " \u00D7 "),
                React.createElement("h1", { className: "testoPopup" }, this.props.t('GreetingsPopupUC.intestazione', { serviceName: this.serviceName })),
                React.createElement("h4", { className: "testoPopup", style: { marginBottom: '-5px' } }, this.props.t('GreetingsPopupUC.intestazione2')),
                React.createElement("h4", { className: "testoPopup" }, this.props.t('GreetingsPopupUC.intestazione3')))));
    }
}
export default translate(connect(_mapStateToProps)(GreetingsPopup));
